module.exports = __webpack_public_path__ + "img/Web.40f17f2e.svg";